if(process.env.REACT_APP_STAGE === 'prod') {
  module.exports = require('./config.prod')
} else {
  module.exports = require('./config.dev')
}
